import { Link } from "@/i18n/navigation";

const PricingFAQ = () => {
  const svg = (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1058_2185)">
        <path
          d="M9.2625 10.7383L15 16.4633L20.7375 10.7383L22.5 12.5008L15 20.0008L7.5 12.5008L9.2625 10.7383Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1058_2185">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  return (
    <div className={"mt-[78px] flex w-full justify-center"}>
      <div className={"w-full max-w-[690px]"}>
        <div className={"w-full text-center text-title1 font-[600] text-black"}>
          자주 묻는 질문
        </div>
        <div className={"mt-[48px] w-full"}>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>Winging을 무료로 사용할 수 있나요?</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              Winging에 회원가입하시면 한 달 동안 사용할 수 있는 크레딧을
              제공합니다.
              <br />
              회원가입한 후 제공된 크레딧으로 Winging의 기능을 자유롭게 체험해
              보세요!
              <div className={"w-full text-right"}>
                <Link
                  href={"/auth/sign-up"}
                  className={"text-primary underline"}
                >
                  회원가입하러 가기
                </Link>
              </div>
            </div>
          </details>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>Starter 요금제와 Pro 요금제는 어떻게 다른가요?</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              <span className={"text-primary"}>Starter 요금제</span>는 개발 없이
              AI 에이전트를 만들고 Winging의 기본 기능을 체험하기 좋은
              플랜이에요. AI 에이전트 1개를 생성할 수 있으며, 챗봇 에디터 기능과
              AI 에이전트 메시지 발송 기능을 활용할 수 있어 처음 도입해보는
              기업에 적합합니다.
              <br />
              <br /> 반면 <span className={"text-primary"}>Pro 요금제</span>는
              Starter의 모든 기능에 더해, 더 정교하고 맞춤형 AI 에이전트를 만들
              수 있는 ‘데이터 튜닝 기능’을 제공해요. 또한 고객과 실제 상담원이
              실시간으로 상담하고 문의 내역을 관리할 수 있는 상담 매니저 기능도
              포함되어 있어 실제 운영 환경에 활용하기 좋습니다. <br />
              <br />
              Starter는 AI 에이전트를 처음 도입하는 기업에게,
              <br /> Pro는 운영 고도화와 성장을 목표로 더 강력한 AI 에이전트를
              구축하고 싶은 기업에게 추천드립니다.{" "}
            </div>
          </details>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>데이터 튜닝 기능이 무엇인가요?</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              데이터 튜닝 기능은 이미 만들어진 AI 에이전트가 더 정확하고
              정교하게 응답할 수 있도록 데이터를 추가하거나 보완하는 기능이에요.
              <br />
              <br />
              새로운 문서나 FAQ를 업로드하면 에이전트가 자동으로 학습해 최신
              정보가 반영되고, 키워드나 응답 가이드를 입력해 고객 문의에 더
              정확하게 응답하도록 조정할 수 있어 기업만의 맞춤형 답변을 제공할
              수 있습니다.
              <br />
              <br />
              즉, AI 에이전트를 우리 회사에{" "}
              <span className={"text-primary"}>
                맞춤형으로 업그레이드하는 기능
              </span>
              이에요.{" "}
            </div>
          </details>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>어떤 요금제를 사용해야 할지 모르겠어요.</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              어떤 요금제가 맞을지 고민되신다면,{" "}
              <span className={"text-primary"}>먼저 Starter 요금제로 시작</span>
              해 보세요.
              <br />
              가볍게 기능을 체험하기에 충분하며, 필요한 시점에 언제든지 Pro로
              업그레이드할 수 있어요!
              <br />
              <br />
              부담 없이 시작하고, 서비스 사용량에 맞춰 확장하시면 됩니다.{" "}
            </div>
          </details>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>어떤 결제 수단을 사용할 수 있나요?</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              Winging은 매달 자동 결제가 가능한{" "}
              <span className={"text-primary"}>카드 결제 방식</span>을
              지원합니다.
              <br />
              <br />
              신용카드 또는 체크카드를 등록하시면 매월 요금이 자동으로 처리돼요.
              <br />
              별도의 수동 결제 없이 편리하게 이용하실 수 있어요!{" "}
            </div>{" "}
          </details>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>이용 중인 요금제를 변경 또는 중단할 수 있나요?</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              네, 언제든지 요금제를 변경하거나 중단하실 수 있어요! <br />
              <br />
              Winging은{" "}
              <span className={"text-primary"}>
                업그레이드와 다운그레이드를 모두 지원
              </span>
              해, 상황에 맞게 자유롭게 조정하실 수 있어요.
              <br />
              단, 업그레이드 직후의 다운그레이드는 다음 달부터 적용되니 이점만
              참고해 주세요.{" "}
            </div>{" "}
          </details>
          <details className={"group w-full"}>
            <summary
              className={
                "flex cursor-pointer list-none items-center justify-between py-[4px] font-[700] text-black [&::-webkit-details-marker]:hidden"
              }
            >
              <span>환불은 어떻게 되나요?</span>
              <span
                className={
                  "text-gray-200 transition-transform group-open:rotate-180 group-open:text-primary"
                }
              >
                {svg}
              </span>
            </summary>
            <div
              className={"break-keep py-[12px] pl-[12px] pr-[32px] text-left"}
            >
              Winging은 선불 정기 구독 방식으로 결제되며, 결제 후 서비스가 바로
              시작돼요.
              <br />
              서비스 이용이 시작된 경우 환불은 어렵습니다.
              <br />
              <br />
              단, 시스템 오류나 이중 결제처럼 회사 사유가 있을 땐 환불이나
              크레딧 환급으로 도와드리고 있어요.
              <br />
              초과 사용분 등 일부 항목은 환불이 어려운 점만 참고해 주세요.
              <br />
              <br />
              환불이 필요하시면 언제든{" "}
              <span className={"text-primary"}>
                고객센터(wilcon@wilcon.ai)로 문의
              </span>
              해 주시면 친절히 안내해 드릴게요.{" "}
            </div>{" "}
          </details>
        </div>
        <div
          className={"mt-[20px] hidden w-full justify-end gap-[10px] lg:flex"}
        >
          <div className={"text-caption2"}>찾으시는 질문이 없나요?</div>
          <Link
            href={"/inquiry"}
            className={"flex items-center gap-[5px] text-caption2 text-primary"}
          >
            문의하기
            <svg
              width="8"
              height="9"
              viewBox="0 0 8 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 7.9425L4.94467 4.5L0 1.0575L1.52227 0L8 4.5L1.52227 9L0 7.9425Z"
                fill="#009EFF"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PricingFAQ;
